import * as React from 'react';
import { PageTitle } from 'gossamer-front-end';

export const Home = (): React.JSX.Element => {
  return (
    <>
      <PageTitle title="Welcome to CareerBook Admin" />
      <div>Manage events, members, groups and rotations.</div>
    </>
  );
};
